export const mountTabLabel = (term) => {
  const pattern = new RegExp(/(\d)[sS]$/g)
  if (pattern.test(term)) {
    return term.replace(pattern, '$1º Semestre')
  }
  return term
}
